<script lang="ts">
  /* A row of actions.
   *
   * ═══ IT WRAPS. THAT IS THE WHOLE COMPONENT ═══
   *
   * `DELETE POINT` and `EXPORT GPX` at 44 px of height with real padding do not
   * fit one row of a 375 px screen. A row that overflows is not a cosmetic
   * problem here: this app shipped its time control 177 px off the right-hand
   * edge of every phone, in production, with the whole proof suite green,
   * because nothing had ever asked where it was.
   *
   * So wrapping is the default and cannot be forgotten, rather than a media
   * query each caller has to remember to write. `RouteContent.svelte` had one;
   * `Sheet.svelte` had none at all.
   */
  import type { Snippet } from 'svelte';

  let {
    /** Push the row to the right — for a foot with one confirming action and a
     *  quieter cancel beside it. Left by default, because a panel's primary
     *  action is read before it is aimed at. */
    align = 'fill',
    children
  }: { align?: 'fill' | 'start' | 'end'; children: Snippet } = $props();
</script>

<div class="btnrow {align}">{@render children()}</div>

<style>
  .btnrow {
    display: flex;
    flex-wrap: wrap;
    gap: var(--sp-4);
  }
  /* Equal shares, which is right for two or three peers — SAVE TRIP beside
     EXPORT GPX. With one child it becomes a full-width button, which is also
     what a single pinned action wants. */
  .btnrow.fill > :global(*) {
    flex: 1 1 auto;
  }
  .btnrow.start {
    justify-content: flex-start;
  }
  .btnrow.end {
    justify-content: flex-end;
  }
</style>
